<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="pageKey"
    :formsConfig="formsConfig"
    :hot-key-grid-tab-index="2"
    class="sales-order-edi"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.CustomerName"
        v-if="model.CustomerName"
      />
    </template>
    <div class="css-v2 transaction-screen" v-if="dataloaded">
      <div class="gc-details-grid">
        <dx-data-grid
          @toolbar-preparing="toolbarPreparing($event)"
          :columns="getColumns"
          :data-source="getDataSource"
          :height="getGridHeight"
          :ref="'salesorderedigrid'"
          :twoWayBindingEnabled="false"
          :columnChooser="{
            enabled: false,
          }"
          :repaint-changes-only="true"
          :selection="{
            mode: baseView.mode === 'review' ? 'none' : 'multiple',
          }"
        >
          <DxPaging :page-size="200" :enabled="false" />
          <DxPager :showInfo="false" />

          <template #statusTemplate>
            <gc-status-chip :status="model.Status" />
          </template>

          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: lineitem }">
            <dx-data-grid
              :columns="getLevelOneColumns"
              :data-source="getLevelOneDataSource(lineitem.data)"
              :twoWayBindingEnabled="false"
              :columnChooser="{
                enabled: false,
              }"
              :repaint-changes-only="true"
            >
              <DxPaging :page-size="200" :enabled="false" />
              <DxPager :showInfo="false" />
              <DxSearchPanel :visible="false" />

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>

              <DxMasterDetail
                :enabled="lineitem.data.IsLevelTwoAvailable"
                template="lTwoMasterDetailTemplate"
              />
              <template #lTwoMasterDetailTemplate="{ data: lineitem }">
                <dx-data-grid
                  :columns="getLevelTwoColumns"
                  :data-source="getLevelTwoDataSource(lineitem.data)"
                  :twoWayBindingEnabled="false"
                  :columnChooser="{
                    enabled: false,
                  }"
                  :repaint-changes-only="true"
                >
                  <DxPaging :page-size="200" :enabled="false" />
                  <DxPager :showInfo="false" />
                  <DxSearchPanel :visible="false" />

                  <template #Decimal="{ data }">
                    <GcDecimal :dataValue="data" :format="data.column.format" />
                  </template>
                </dx-data-grid>
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>
    </div>
  </gc-main-layout>
</template>

<script>
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { SalesOrderBatchAllocationsService } from "../../_services/api/sales/sales-order-batch-allocations.service";
import { SalesOrderEDIService } from "../../_services/api/sales/sales-order-edi.service";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { FeatureStorage } from "../../_services/storage";
import BaseViewMixin from "../../v1/_mixins/base.view";
import { mapGetters } from "vuex";

export default {
  props: {},
  components: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      model: {
        CustomerCode: "",
        CustomerName: "",
        Name: "",
        Status: "A",
      },
      isBatchAllocationVisible: false,
      dataloaded: false,
      soEDIStore: new ArrayStore({
        key: "ID",
        data: [],
      }),
      disableInvoiceOrder: false,
      disableASN: false,
      disableINV: false,
    };
  },
  async created() {
    this.showLoading(true);
    this.model.Name = `Sales Order # ${this.baseView.id}`;
    this.selectedIndex = 2;
    await SalesOrderBatchAllocationsService.getSalesOrderDetailsByCode({
      filter: `SalesOrderCode eq ${this.baseView.id} and IsBatchProduct ne 'No'`,
      top: 1,
    })
      .then(async (so) => {
        if (so.data.value.length === 0) this.isBatchAllocationVisible = false;
        else {
          await SalesOrderBatchAllocationsService.getBatchAllocationRule()
            .then(async (res) => {
              if (res.data.value.length > 0) {
                if (res.data.value[0].RuleAction !== "N") {
                  this.isBatchAllocationVisible = true;
                } else {
                  this.isBatchAllocationVisible = false;
                }
              }
            })
            .catch(() => {
              this.showLoading(false);
            });
        }
      })
      .catch(() => {
        this.showLoading(false);
      });
    await this.getSalesOrder();
    await this.getSSCCDetails();

    setTimeout(() => {
      this.$nextTick(() => {
        this.showLoading(false);
        this.dataloaded = true;
      });
    }, 10);
  },

  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    tabs() {
      return [
        {
          text: "Order",
          path: `/sales-order/${this.baseView.mode}/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrder",
        },
        {
          text: "Batch Allocation",
          path: `/sales-order-batch-allocations/${this.baseView.mode}/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrder",
          disabled: !this.isBatchAllocationVisible || this.model.Status === "P",
        },
        {
          text: "EDI",
          path: `/sales-order-edi/${this.baseView.id}`,
          applicationFeatureCode: "SalesOrderEDI",
        },
        {
          text: "Lot Assignment",
          path: `/almondco-inshell-sales-order-lot-assignment/review/${this.baseView.id}`,
          applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
          visible: FeatureStorage.checkPermission(
            "AlmondcoInshellSalesOrderLotAssignment",
            "review"
          ),
        },
      ];
    },

    getColumns() {
      return [
        {
          caption: "",
          dataField: "",
          type: "detailExpand",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 0,
          width: 30,
          minWidth: 30,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 1,
          visible: this.baseView.mode !== "review",
        },
        {
          caption: "Product / Account",
          dataField: "ItemDescription",
          sortOrder: "asc",
          sortIndex: 0,
          // cssClass: "class-item-cell-template",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete" @click="clickOnInfo(${info})">
                        <span class="auto-complete-primary">
                          ${info.data.ItemDescription}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.ItemCode}
                        </span>
                      </div>`);
          },
          allowEditing: false,
          minWidth: 420,
          // tabindex: -1,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          allowEditing: false,
          allowSorting: false,
          width: ColumnWidth.UnitOfMeasure.width,
          maxWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          caption: "Order Quantity",
          dataField: "SalesUMQty",
          allowEditing: false,
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
      ];
    },
    getDataSource() {
      return this.soEDIStore;
    },
    getGridHeight() {
      return this.gridHeight - 20; // - 40;// - 55;
    },

    getLevelOneColumns() {
      return [
        {
          captiop: "SSCC",
          dataField: "SSCC",
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          type: "buttons",
          width: 50,
          buttons: [
            {
              hint: "Add Batch Line",
              icon: "print",
              visible: true,
              onClick: this.printSOLineLevel.bind(this),
            },
          ],
        },
      ];
    },
    getLevelTwoColumns() {
      return [
        {
          caption: "Batch",
          dataField: "BatchNo",
        },
        {
          caption: "Supplier",
          dataField: "SupplierCode",
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete" @click="clickOnInfo(${info})">
                        <span class="auto-complete-primary">
                          ${info.data.SupplierName}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${info.data.SupplierCode}
                        </span>
                      </div>`);
          },
        },
        {
          caption: "Use By / Best Before",
          dataField: "DisplayDate",
          width: ColumnWidth.Date.width + 30,
          maxWidth: ColumnWidth.Date.minWidth + 30,
          format: "dd MMM yyyy",
          type: "date",
        },
        {
          caption: "Quantity",
          dataField: "StockUMQty",
          format: "##,###,###,###,##0.0000",
          dataType: "number",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
      ];
    },
  },

  methods: {
    getLevelOneDataSource(e) {
      return e.LevelOneDataSource;
    },
    getLevelTwoDataSource(e) {
      return e.LevelTwoDataSource;
    },
    async getSalesOrder() {
      this.disableInvoiceOrder = false;
      this.disableASN = false;
      this.disableINV = false;

      await SalesOrderService.getByCode(this.baseView.id)
        .then(async (response) => {
          this.model.CustomerName = response.data.value[0].Customer.Name;
          this.model.CustomerCode = response.data.value[0].CustomerCode;
          this.model.Status = response.data.value[0].Status;
          this.model.BranchCode = response.data.value[0].BranchCode;

          if (this.model.Status === "P") {
            this.disableASN = true;
            this.disableINV = true;
            this.disableInvoiceOrder = true;
          }

          await SalesOrderEDIService.getSalesOrderEDIByCode(
            this.baseView.id
          ).then(async (res) => {
            if (res.data.value.length > 0) {
              let ediData = res.data.value[0];
              if (ediData.POASent === "Y") {
                // eslint-disable-next-line no-unused-vars
                await SalesOrderEDIService.getTop1Invoice(
                  this.baseView.id
                ).then(async (response2) => {
                  let invoice = response2.data.value;
                  if (invoice.length == 1) {
                    this.disableInvoiceOrder = true;

                    await SalesOrderEDIService.getEDICustomerDocumentTypeByCustomerCode(
                      this.model.CustomerCode
                    ).then(async (res3) => {
                      let asnResult = res3.data.value.filter(
                        (a) => a.EDIDocumentTypeCode == "ASN"
                      );
                      let invResult = res3.data.value.filter(
                        (a) => a.EDIDocumentTypeCode == "INV"
                      );

                      if (asnResult == null || asnResult == "") {
                        this.disableASN = true;
                      }
                      if (invResult == null || invResult == "") {
                        this.disableINV = true;
                      }
                    });
                  } else {
                    this.disableASN = true;
                    this.disableINV = true;
                  }
                });
              } else {
                this.disableASN = true;
                this.disableINV = true;
              }
            }
          });

          this.refreshView();
        })
        .catch(() => {
          this.showLoading(false);
        });
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/sales-order",
      });
    },

    async toolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      let itemsToRemoveFromToolBar = ["searchPanel"];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            text:
              this.soEDIStore._array.length != 0
                ? "Regenerate SSCC ID"
                : "Generate SSCC ID",
            icon: "refresh",
            elementAttr: {
              class: "generate-sscc-btn",
            },
            onClick: () => {
              this.generateSSCCIDs();
            },
          },
          visible:
            FeatureStorage.checkPermission("SalesOrder", "create") &&
            this.model.Status === "A",
        },
        // searchPanel,
        {
          location: "after",
          template: "statusTemplate",
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxDropDownButton",
          options: {
            showArrowIcon: false,
            icon: "overflow",
            items: [
              { menuText: "Print SSCC Labels" },
              { menuText: "Invoice Order", disabled: this.disableInvoiceOrder },
              { menuText: "Send ASN", disabled: this.disableASN },
              { menuText: "Send INV", disabled: this.disableINV },
            ],
            keyExpr: "menuText",
            displayExpr: "menuText",
            onItemClick: async (e) => {
              if (e) {
                let salesOrder = parseInt(this.baseView.id);
                this.showLoading(true);
                if (e.itemData.menuText === "Print SSCC Labels") {
                  SalesOrderEDIService.printSalesOrderSSCC({
                    SSCC: undefined,
                    SalesOrderCode: salesOrder,
                    SalesOrderLine: undefined,
                  })
                    .then((result) => {
                      if (result) this.showLoading(false);
                      this.$notify(
                        `Successfully queued Sales Order ${salesOrder} for SSCC label printing`,
                        "success"
                      );
                    })
                    .catch((error) => {
                      this.showLoading(false);
                      this.displayServerError(
                        error,
                        "Print SSCC Labels Failed"
                      );
                    });
                } else if (e.itemData.menuText == "Invoice Order") {
                  SalesOrderEDIService.invoiceSalesOrder(salesOrder)
                    // eslint-disable-next-line no-unused-vars
                    .then(async (result) => {
                      this.$notify(
                        `Successfully invoiced Sales Order ${salesOrder}`,
                        "success"
                      );
                      await this.getSalesOrder();
                      this.showLoading(false);
                    })
                    .catch((error) => {
                      this.showLoading(false);
                      this.displayServerError(error, "Invoice Order Failed");
                    });
                } else if (e.itemData.menuText == "Send ASN") {
                  SalesOrderEDIService.sendSalesOrderEDIASN(salesOrder)
                    // eslint-disable-next-line no-unused-vars
                    .then(async (result) => {
                      this.$notify(
                        `Successfully queued ASN for Sales Order ${salesOrder}`,
                        "success"
                      );

                      await this.getSalesOrder();
                      this.showLoading(false);
                    })
                    .catch((error) => {
                      this.showLoading(false);
                      this.displayServerError(error, "Send ASN Failed");
                    });
                } else if (e.itemData.menuText == "Send INV") {
                  SalesOrderEDIService.sendSalesOrderEDIINV(salesOrder)
                    // eslint-disable-next-line no-unused-vars
                    .then(async (result) => {
                      this.$notify(
                        `Successfully queued INV for Sales Order ${salesOrder}`,
                        "success"
                      );

                      await this.getSalesOrder();
                      this.showLoading(false);
                    })
                    .catch((error) => {
                      this.showLoading(false);
                      this.displayServerError(error, "Send INV Failed");
                    });
                } else {
                  this.showLoading(false);
                }
              }
            },
            dropDownOptions: {
              minWidth: 130,
            },
          },
          visible:
            FeatureStorage.checkPermission("SalesOrder", "create") &&
            this.soEDIStore._array.length != 0,
        }
      );
    },

    printSOLineLevel(e) {
      if (e) {
        this.showLoading(true);
        let data = e.row.data;

        SalesOrderEDIService.printSalesOrderSSCC({
          SSCC: data.SSCC,
          SalesOrderCode: data.SalesOrderCode,
          SalesOrderLine: data.SalesOrderLineNo,
        })
          .then((result) => {
            if (result) this.showLoading(false);
            this.$notify(`Successfully queued SSCC label printing`, "success");
          })
          .catch((error) => {
            this.showLoading(false);
            this.displayServerError(error, "Print SSCC Labels Failed");
          });
      }
    },

    async getSSCCDetails() {
      this.soEDIStore.clear();
      await SalesOrderEDIService.getSSCCHeader(this.baseView.id)
        .then((res) => {
          if (res.data.value.length > 0) {
            const uniqueSalesOrderLineItems = Array.from(
              new Map(
                res.data.value.map((item) => [
                  item.SalesOrderLineNo,
                  {
                    SalesOrderLineNo: item.SalesOrderLineNo,
                    ItemCode: item.ItemCode,
                    ItemDescription: item.ItemDescription,
                    RecordId: item.RecordId,
                    SalesUM: item.SalesUM,
                    SalesUMQty: 0,
                    IsLevelTwoAvailable: false,
                  },
                ])
              ).values()
            );

            uniqueSalesOrderLineItems.forEach((element, index) => {
              element.ID = index + 1;
              element.LevelOneDataSource = [];

              res.data.value.forEach((level) => {
                if (level.SalesOrderLineNo === element.SalesOrderLineNo) {
                  element.LevelOneDataSource.push({
                    SSCC: level.SSCC,
                    SalesUMQty: level.SalesUMQty,
                    SalesOrderCode: level.SalesOrderCode,
                    SalesOrderLineNo: level.SalesOrderLineNo,
                    RecordId: level.RecordId,
                    LevelTwoDataSource: [],
                  });

                  element.SalesUMQty += level.SalesUMQty;
                }
              });

              this.soEDIStore.insert(element);
            });
          }
        })
        .catch(() => {
          this.showLoading(false);
        });

      this.soEDIStore._array.forEach(async (element) => {
        element.LevelOneDataSource.forEach(async (lOneItem) => {
          await SalesOrderEDIService.getSSCCDetails(lOneItem.RecordId)
            .then((res) => {
              if (res.data.value.length > 0) {
                res.data.value.forEach((item) => {
                  if (item.BestBeforeDate)
                    item.DisplayDate = new Date(item.BestBeforeDate);

                  if (item.UseByDate)
                    item.DisplayDate = new Date(item.UseByDate);
                });

                lOneItem.LevelTwoDataSource = res.data.value;
                element.IsLevelTwoAvailable = true;
              }
            })
            .catch(() => {
              this.showLoading(false);
            });
        });
      });
    },

    repaintGrid() {
      let grid = this.$refs["salesorderedigrid"];
      if (grid) {
        let gridInstance = grid.instance;
        gridInstance.repaint();
      }
    },

    async generateSSCCIDs() {
      this.showLoading(true);
      let TotalSalesUMQty = undefined;
      let TotalBatchAllocatedQty = undefined;

      await SalesOrderEDIService.getSOLinesTotalQty(this.baseView.id)
        .then((res) => {
          if (res.data.value.length > 0)
            TotalSalesUMQty = res.data.value[0].TotalSalesUMQty;
        })
        .catch(() => {
          this.showLoading(false);
        });

      await SalesOrderEDIService.getBatchLineTotalAllocations(
        this.model.BranchCode,
        this.baseView.id
      )
        .then((res) => {
          if (res.data.value.length > 0)
            TotalBatchAllocatedQty = res.data.value[0].TotalBatchAllocatedQty;
        })
        .catch(() => {
          this.showLoading(false);
        });

      if (TotalBatchAllocatedQty < TotalSalesUMQty) {
        this.showLoading(false);
        this.$alert(
          "The SSCC generation cannot proceed due to one or more Batch Allocation for this order is less than the Order Qty",
          "Warning"
        );
      } else {
        await SalesOrderEDIService.SaveProcessEDISalesOrder(this.baseView.id)
          .then(async () => {
            this.showLoading(false);
            this.$notify(`SSCC generation has been completed.`, "success");

            await this.getSSCCDetails();

            let grid = this.$refs["salesorderedigrid"];
            if (grid) {
              let gridInstance = grid.instance;
              gridInstance.repaint();

              this.$nextTick(() => {
                gridInstance.refresh(true);
              });
            }
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.sales-order-edi {
  .dx-button.generate-sscc-btn {
    background-color: #03a9f4 !important;
    color: #fff !important;

    .dx-icon {
      color: #fff !important;
      margin: 0 !important;
    }

    .dx-icon::before {
      color: unset;
    }

    span {
      padding-right: 5px;
    }
  }

  .dx-datagrid-headers[role="presentation"] {
    padding-right: unset !important;
  }

  div.dx-datagrid-content.dx-datagrid-content-fixed {
    margin-right: unset !important;
  }

  .dx-datagrid-table.dx-datagrid-table-fixed {
    td.dx-master-detail-cell {
      padding-right: unset !important;
    }
  }
}
</style>
